module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget-search-box"
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shouldShowInput),
      expression: "shouldShowInput"
    }],
    attrs: {
      "placeholder": _vm.placeholder,
      "clearable": ""
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-search",
    on: {
      "click": _vm.toggle
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-f1dddd50!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/widgetSearchBox.vue
// module id = 484
// module chunks = 11